// extracted by mini-css-extract-plugin
module.exports = {"root":"Vote-module__root___3Gswb","icon":"Vote-module__icon___2oTkK","iconActive":"Vote-module__iconActive___2ldHK"};